import { Box, Flex } from "@chakra-ui/react"
import { useEffect, useState } from "react"
import { useLocation } from "react-router-dom"
import { breadCrumbFirstLevel, breadCrumbProductsSecondLevel, imageSliderWidth, imageSliderWidth2XL, imageSliderWidthXL } from "../common/commonConstants"
import { ImageSlider } from "../components/ImageSlider/image-slider.main"
import { SubPage, SubPageContent } from "../components/SubPage"
import { BreadCrumb } from "../components/commons/breadcrumb"
import { ProductInfo } from "../components/productInfo/product-info.main"
import { ProductInfoTable } from "../components/productInfo/product-info.sub.table"

export const Product = (): JSX.Element => {
  const location = useLocation()
  const [thirdLevelPath, setThirdLevelPath] = useState<string>("")
  const [thirdLevelName, setThirdLevelName] = useState<string>("")
  const [fourthLevelName, setFourthLevelName] = useState<string>("")

  useEffect(() => {
    if (location) {
      const pathArr = location.pathname.split("/")
      setThirdLevelPath("/" + pathArr[1] + "/" + pathArr[2])
      setFourthLevelName(pathArr[3])
      const catName = pathArr[2]
        .replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
          return word.toUpperCase()
        })
        .replace(/\s+/g, "")
        .replace("-Fire-Collars", " Fire Collars")
        .replace("Electrical-&-Data", "Data & Electrical Fire Collars")
      setThirdLevelName(catName)
    }
  }, [location])

  return (
    <SubPage>
      <BreadCrumb
        options={{
          ...breadCrumbFirstLevel,
          ...breadCrumbProductsSecondLevel,
          thirdLevel: { title: thirdLevelName, path: thirdLevelPath },
          fourthLevel: { title: fourthLevelName }
        }}
      />
      <SubPageContent props={{ pt: "14px" }}>
        <Flex
          flexWrap={["wrap", "wrap", "wrap", "nowrap"]}
          align={["flex-start", "flex-start", "flex-start", "stretch"]}
          justify={"center"}
          mt={"0"}
        >
          <Box width={["100%", "100%", "100%", imageSliderWidth, imageSliderWidthXL, imageSliderWidth2XL]} pt="14px">
            <ImageSlider />
          </Box>

          <ProductInfo />
        </Flex>
        {/* Tabbed table */}
        <ProductInfoTable />
      </SubPageContent>
    </SubPage>
  )
}
